export default __webpack_public_path__ + "static/media/031-parachute.7c8a0942.png";